import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {Team, Permissions, TeamPermissions} from "@irati/types"

import {H3, H4} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import {Para} from "@irati/ui/src/Labels"

import Button from "./styled/Button"
import {Row, RowMiddle, RowEnd} from "../../Row/index"
import Products from "../../Products"
import TeamNameRowStart from "./styled/TeamNameRowStart"
import TeamNameRowMiddle from "./styled/TeamNameRowMiddle"

interface Props {
  uuid: string,
  setCurrentTeam?: (team: Team) => void,
  public_name: string,
  permissionsForTeam?: TeamPermissions,
  permissionsForTenant?: Permissions,
  hideHr?: boolean,
  buttonText?: string,
  largeHeading?: boolean,
  team: Team
}

class TeamRow extends PureComponent<Props> {
  render() {
    const {
      setCurrentTeam,
      public_name,
      permissionsForTeam,
      permissionsForTenant,
      hideHr,
      buttonText,
      largeHeading,
      team
    } = this.props
    const teamButtonText = buttonText || "admin.components.team.button.text"
    const Heading = largeHeading ? H3 : H4

    return (
      <>
        {!hideHr && <Hr />}
        <Row>
          <TeamNameRowStart>
            <Heading>{public_name}</Heading>
          </TeamNameRowStart>
          <RowMiddle>
            <TeamNameRowMiddle>
              <Para>
                <FormattedMessage id="admin.components.team.activePeople.text" values={{total: team.users?.total}} />
              </Para>
            </TeamNameRowMiddle>
            <Para>
              <FormattedMessage id="admin.components.team.managers.text" values={{total: team.managers?.total}} />
            </Para>
          </RowMiddle>
          {permissionsForTenant && <Products permissionsForTeam={permissionsForTeam} permissionsForTenant={permissionsForTenant} />}
          <RowEnd>
            {setCurrentTeam && (
              <Button onClick={setCurrentTeam} small id={`button_viewTeam_${public_name}`}>
                <FormattedMessage id={teamButtonText} />
              </Button>
            )}
          </RowEnd>
        </Row>
      </>
    )
  }
}

export default TeamRow
